import { usePeopleFiltersContext } from '@sales-app/context/peopleFilters/peopleFilters'
import clsx from 'clsx'
import React from 'react'

export const DuplicateFilter = () => {
  const { setFilters, includeDuplicates } = usePeopleFiltersContext()

  const changeFilter = () => {
    if (!includeDuplicates) {
      setFilters({ includeDuplicates: true })
    } else {
      setFilters({ includeDuplicates: null })
    }
  }

  return (
    <button
      className={clsx(
        'flex h-10 sm:max-w-max flex-row items-center justify-between rounded-lg border px-4 border-secondary md:min-w-52',
        !!includeDuplicates ? 'bg-action-input text-white' : 'bg-white',
      )}
      onClick={changeFilter}
    >
      <div className="flex flex-row items-center">
        <span className="text-xs md:text-sm">Potential Duplicates</span>
      </div>
    </button>
  )
}
